import React, { Component } from 'react';
import { Container } from 'reactstrap';
import EirDeviceDetails from '../eir-device-details/EirDeviceDetails';
import { currentUser } from '../../services/CurrentUser'
import Routing from '../../utils/Routing'
import PubSub from 'pubsub-js';
import Constants from '../../Constants';
import Loading from '../shared/Loading';

class EirDeviceDetailsContainer extends Component {

  constructor(props) {
    super(props);
    this.modalChangedToken = null;
    this.state = {
      isLoading: true,
      userInputRequired: false,
      selectedToggleAttribute: null,
      toggleAttributes: this.getAllToggleAttributes(),

    };
  }

  componentWillUnmount() {
    if (this.modalChangedToken) {
      PubSub.unsubscribe(this.modalChangedToken);
    }

    if (this.upgradeStatusChangedToken) {
      PubSub.unsubscribe(this.upgradeStatusChangedToken);
    }

    
    if (this.cartContentChangedTokenn) {
      PubSub.unsubscribe(this.cartContentChangedToken);
    }
  }

  async componentDidMount() {
    this.modalChangedToken = PubSub.subscribe(Constants.eventKeys.modalContentSelected, this.modalValueSelected);
    this.upgradeStatusChangedToken = PubSub.subscribe(Constants.eventKeys.upgradeStatusChanged, this.handleUpgradeStatusChanged);
    this.cartContentChangedToken = PubSub.subscribe(Constants.eventKeys.cartContentChanged, this.cartContentChanged);

    let selectedToggleAttribute = null;

    if(this.props.toggleAttributeName) {
      // first check the query string for a value
      let selectedToggleValue = Routing.getQueryParameter(this.props.toggleAttributeName);

      // if the query string came up with nothing, check if the user has it set
      if (selectedToggleValue == null) {
        selectedToggleValue = currentUser.getAttribute(this.props.toggleAttributeName);
      }

      this.props.deviceDetails.forEach(deviceDetail => {
        deviceDetail.attributes.forEach(attribute => {
          if (attribute.name === this.props.toggleAttributeName && attribute.value && attribute.value === selectedToggleValue) {
            selectedToggleAttribute = attribute;
          }
        });
      });
    }

    this.handleToggleValueSelected(selectedToggleAttribute);
  }
  
  modalValueSelected = (msg, selectedToggleAttribute) => {
    this.handleToggleValueSelected(selectedToggleAttribute);
  }

  handleUpgradeStatusChanged = () => {

    PubSub.publish(Constants.eventKeys.deviceDetailsPriceInvalid, null);
    
    this.fetchData(() => { 
      PubSub.publish(Constants.eventKeys.deviceDetailsPriceChanged, this.state.device.details.prices);
    });
  }

  cartContentChanged = (msg, cart) => {
    PubSub.publish(Constants.eventKeys.modalHideRetrieved, (cart.numberOfProducts > 0));
    
  }

  publishModalDetails() {
    if (this.props.toggleAttributeName && this.props.toggleText) {
      var modalDetails = {
        isOpen: this.state.userInputRequired,
        question:this.props.toggleText,
        answers: this.state.toggleAttributes,
        selectedAnswer: this.state.selectedToggleAttribute
      }
      PubSub.publish(Constants.eventKeys.modalContentRetrieved, modalDetails);
    }
  }

  handleToggleValueSelected = (selectedToggleAttribute) => {
    let deviceDetail = null;
    var userInputRequired = null;

    if (selectedToggleAttribute) {
      currentUser.setAttribute(this.props.toggleAttributeName, selectedToggleAttribute.value);

      // the toggle attribute is set and the value is set
      if (this.props.toggleAttributeName && this.props.toggleAttributeName && selectedToggleAttribute && selectedToggleAttribute.value) {
        deviceDetail = this.props.deviceDetails.find(deviceDetail => deviceDetail.attributes.some(attribute => attribute.name && attribute.value && attribute.name.toUpperCase() === this.props.toggleAttributeName.toUpperCase() && selectedToggleAttribute.value.toUpperCase() === attribute.value.toUpperCase()));
      }
      userInputRequired = false;
    } 
    else {
      if (this.state.toggleAttributes && this.state.toggleAttributes.length > 0) {
        selectedToggleAttribute = this.state.toggleAttributes[0];
      }
      userInputRequired = true;
    }

    this.setState({
      selectedToggleAttribute: selectedToggleAttribute,
      userInputRequired: userInputRequired
    });

    if (!deviceDetail) {
      deviceDetail = this.props.deviceDetails[0];
    }

    this.setState({
      deviceDetail: deviceDetail
    },
    this.getDeviceData);
  };
  
  async getDeviceData() {
    
    this.setState({ 
      isLoading: true 
    });
    
      await this.fetchData();
    
      this.publishModalDetails();

      this.setState({
        isLoading: false
      });
     
  }

  async fetchData(callback) {
   
    let attributes = this.state.deviceDetail.attributes.map(attribute => attribute.name + '=' + attribute.value).join('&');
    let response = await fetch(this.props.dataUrl + '?'+ attributes);

    this.setState({
      device: await response.json()
    }, callback);
  }

  getAllToggleAttributes() {
    let toggleAttributes = [];

    this.props.deviceDetails.forEach(deviceDetail => {
      toggleAttributes = toggleAttributes.concat(deviceDetail.attributes.filter(attribute => attribute.name === this.props.toggleAttributeName));
    });

    return toggleAttributes;
  }

  showModal = () => {
    this.modal.handleToggle();
  };

  render() {

    if (this.state.error) {
      return (<h2 className="text-center">Error</h2>);
        }
    else if (this.state.isLoading) {
      return (<Loading className="m-5" />);
        }
    else {

    return (
      <Container className="device-details-container mt-5 mb-6">
          <EirDeviceDetails 
            outOfStockForm={this.props.outOfStockForm}
            device={this.state.device}
            preOrderMessage={this.props.preOrderMessage}
            cartSummary={this.props.cartSummary}
            upgradeChecker={this.props.upgradeChecker}
            priceTypes={this.props.priceTypes}
            />
      </Container>
    );
    }
  }
}

export default EirDeviceDetailsContainer;
